<template>
  <v-container fluid class="list-page">
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    />
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editSubject="selectedSubject"
    />

    <div class="list-page-heading">
      <div><div class="list-page-heading__eyebrow">Report cards</div><h1>Subjects</h1><p>Manage the subjects available for curriculums and report cards.</p></div>
      <div class="list-page-heading__actions">
        <v-btn v-if="checkRightStatus(41)" color="primary" depressed @click="add"><v-icon left>mdi-plus</v-icon>New subject</v-btn>
      </div>
    </div>

    <v-row class="list-metrics">
      <v-col cols="6" sm="4" md="3"><div class="list-metric"><div class="list-metric__icon"><v-icon color="primary" size="21">mdi-book-open-variant</v-icon></div><div><div class="list-metric__value">{{ filteredSubjects.length }}</div><div class="list-metric__label">Subjects in result</div></div></div></v-col>
    </v-row>

    <v-card :loading="loading" elevation="0" class="list-card">
      <div class="list-toolbar">
        <v-text-field v-model="search" class="list-toolbar__search" outlined prepend-inner-icon="mdi-magnify" dense background-color="#F8FAF8" placeholder="Search subjects" single-line hide-details clearable />
        <div class="list-toolbar__actions"><v-btn icon outlined color="primary" :loading="loading" aria-label="Refresh subjects" @click="getList"><v-icon size="19">mdi-refresh</v-icon></v-btn></div>
      </div>
      <v-data-table
        class="list-table list-table--responsive"
        :headers="headers"
        :items="subjects"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="list-table-row">
            <td data-label="Subject">
              <div class="list-identity"><div class="list-identity__icon"><v-icon color="primary" size="19">mdi-book-outline</v-icon></div><div class="list-identity__content"><div class="list-identity__title text-capitalize">{{ item.name }}</div><div class="list-identity__subtitle">Available for curriculum assignment</div></div></div>
            </td>
            <td data-label="Actions" class="justify-end align-center text-right action-cell">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    v-if="checkRightStatus(43)"
                    @click="editSubject(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item
                    v-if="checkRightStatus(44)"
                    @click="deleteSubject(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <template v-slot:no-data><div class="list-empty-state py-12"><v-icon size="48" color="grey lighten-1">mdi-book-search-outline</v-icon><strong>No subjects found</strong><span>{{ search ? "Try a different subject name." : "Create a subject to begin building curriculums." }}</span></div></template>
        <template v-slot:no-results><div class="list-empty-state py-12"><v-icon size="48" color="grey lighten-1">mdi-book-search-outline</v-icon><strong>No subjects found</strong><span>Try a different subject name.</span></div></template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import subjectService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  name: "subject-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedSubject: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          width: '60',
          sortable: false,
        },
      ],
      subjects: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "createdAt",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Subject List";
  },
  components: {
    Create,
    Edit,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    filteredSubjects() {
      if (!this.search) return this.subjects;
      const search = this.search.toLowerCase();
      return this.subjects.filter((subject) => (subject.name || "").toLowerCase().includes(search));
    },
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false 
      this.createDialog = false
      return subjectService.getAll().then((response) => {
        this.loading = false;
        this.subjects = response.data;
        return response;
      });
    },
    editSubject(subject) {
      this.selectedSubject = subject;
      this.editDialog = !this.editDialog;
    },
    deleteSubject(subject) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          subjectService.delete(subject.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Subject has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
